import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { message } from 'ant-design-vue';
import TimeRangeEditor from './TimeRangeEditor.vue';
import { useTimeRange } from '../hooks/useTimeRange';
export default /*#__PURE__*/_defineComponent({
  __name: 'BatchQueryTimeModal',
  props: {
    open: {
      type: Boolean
    },
    count: null
  },
  emits: ["update:open", "submit"],
  setup(__props, {
    expose,
    emit
  }) {
    const {
      validateRanges
    } = useTimeRange();
    const mode = ref('unlimited');
    const ranges = ref([{
      startDate: '',
      endDate: ''
    }]);
    const saving = ref(false);
    const resetState = () => {
      mode.value = 'unlimited';
      ranges.value = [{
        startDate: '',
        endDate: ''
      }];
      saving.value = false;
    };
    const handleCancel = () => {
      resetState();
      emit('update:open', false);
    };
    const handleOk = () => {
      if (mode.value === 'unlimited') {
        emit('submit', {
          queryTimeMode: 'unlimited',
          timeRanges: []
        });
        return;
      }
      // 与单个产品编辑共用同一份校验，保证行为完全一致
      const result = validateRanges(ranges.value);
      if (!result.ok) {
        message.warning(result.message);
        return;
      }
      emit('submit', {
        queryTimeMode: 'ranges',
        timeRanges: result.ranges || []
      });
    };
    const close = () => {
      resetState();
      emit('update:open', false);
    };
    const setSaving = value => {
      saving.value = value;
    };
    expose({
      close,
      setSaving
    });
    return (_ctx, _cache) => {
      const _component_a_alert = _resolveComponent("a-alert");
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.open,
        title: "批量修改查询时间",
        "ok-text": "保 存",
        "cancel-text": "取 消",
        "confirm-loading": saving.value,
        "mask-closable": false,
        onOk: handleOk,
        onCancel: handleCancel
      }, {
        default: _withCtx(() => [_createVNode(_component_a_alert, {
          class: "selected-tip",
          type: "info",
          "show-icon": "",
          message: `已选择 ${__props.count} 个产品`
        }, null, 8, ["message"]), _createVNode(_component_a_form, {
          "label-col": {
            span: 24
          },
          "wrapper-col": {
            span: 24
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "查询时间",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_radio_group, {
              value: mode.value,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => mode.value = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_a_radio, {
                value: "unlimited"
              }, {
                default: _withCtx(() => [_createTextVNode("不限")]),
                _: 1
              }), _createVNode(_component_a_radio, {
                value: "ranges"
              }, {
                default: _withCtx(() => [_createTextVNode("指定时间段")]),
                _: 1
              })]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          }), mode.value === 'ranges' ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 0,
            label: "时间段",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(TimeRangeEditor, {
              modelValue: ranges.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ranges.value = $event),
              "remove-style": "text"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["open", "confirm-loading"]);
    };
  }
});